module.exports = __webpack_public_path__ + "img/step1-t.7b6e8a8a.png";